import React from 'react'
import { connect } from 'react-redux'
import Titulo from '../comum/Titulo';
import buscarRotas from '../../actions/rota-itinerario/buscarRotasItinerario';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import {
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import {alterarExibicaoDetalhamentoRotaItinerario} from '../../actions/rota-itinerario/alterarExibicacaoDetalhamentoRotaItinerario';
import PainelFiltragem from './PainelFiltrosDisponiveisInternet';
import determinarPaginaAtual from '../../actions/rota-itinerario/determinarPaginaAtualRotaItinerario';
import alterarRegistrosPorPagina from '../../actions/rota-itinerario/alterarRegistrosPorPaginasRotaItinerario';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoRotas from './PaginacaoDisponiveisInternet';
import BotoesPaginacaoRotas from './BotoesPaginacaoDisponiveisInternet';
import RotasItinerario from './RotasItinerario'

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col-lg-1 col-xl-1"></div>
            <div className="col-lg-1 col-xl-1">N° Rota</div>
            <div className="col-lg-3 col-xl-3">Nome Empresa</div>
            <div className="col-lg-3 col-xl-3">Rota</div>
            <div className="col-lg-2 col-xl-2">Delimitação</div>
        </div>
    </div>
);

export class PainelDisponiveisInternet extends React.Component {
    constructor(props) {
        super(props);
        this.alterarExibicao = this.alterarExibicao.bind(this);
    }

    buscarRotas() {
        this.props.buscarRotas(this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidMount() {
        this.buscarRotas();
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarRotas();
            if (!alterouPagina(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
            }
        }
    }

    alterarExibicao(rota) {
        this.props.alterarExibicaoDetalhamentoRotaItinerario(rota, false)
    }

    exibirTabelaRotasItinerario() {
        if (this.props.rotas && this.props.rotas.length) {
            return (<CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoRotas}
                BotoesPaginacao={BotoesPaginacaoRotas}
                rotas={this.props.rotas}>
                <CabecalhoTabela />
                <div className="lista-table">
                    {this.exibirRotasItinerario()}
                </div>
            </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhum rota com itinerário disponível para venda.</div>;
    }

    exibirRotasItinerario() {
        return this.props.rotas
            .map((rota, index) => <RotasItinerario
                key={index} rota={rota} alterarExibicao={this.alterarExibicao} indice={index} />)
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Disponíveis Internet" urlRetorno="/selecao-empresa"/>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <div className="col-12 filtro-busca">
                                <PainelFiltragem />
                            </div>
                            {this.exibirTabelaRotasItinerario()}
                        </div>
                    </div>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => {
    return {
        empresas: state.empresas,
        empresaSelecionada: state.empresaSelecionada,
        rotas: state.rotasItinerario.rota,
        paginaAtual: state.paginaAtualRotaItinerario,
        registrosPorPagina: state.registrosPorPaginaRotaItinerario,
        filtrosAdicionados: state.filtrosAdicionadosRotaItinerario,
    }};

export default connect(mapStateToProps, {
    buscarRotas,
    alterarExibicaoDetalhamentoRotaItinerario,
    determinarPaginaAtual,
    alterarRegistrosPorPagina
})(PainelDisponiveisInternet)
